import { JSX } from "react";

const EventAdminReviewRoute = ({ children }: { children: JSX.Element }) => {
  return children;
};

export default EventAdminReviewRoute;
